// extracted by mini-css-extract-plugin
export default {"component":"AcKM1","item":"UHId8"};